import React, { useState, useEffect } from "react";
import {
  Typography,
  Icon,
  IconButton,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "../../components/Loader";
import * as moment from "moment";

import { FARMS } from "../../configs/urls";
import { getApi, deleteApi } from "../../services/api";
import { DATE_FORMATS } from "../../configs/constant";
import { useHistory } from "react-router-dom";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "../../components/CustomButtons/Button.js";

const navBarStyles = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

export default function FarmList(props) {
  const classes = useStyles();
  const [farmsList, setFarmsList] = useState([]);
  const [selectedFarm, setSelectedFarm] = useState([]);
  const [isRequesting, setIsRequestig] = useState(false);
  const [params, setParams] = useState({ page: 0, size: 10 });
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const [viewSectorOfficerData, setViewSectorOfficerData] = useState({
    isDialogOpen: false,
    sectorOfficerList: [],
  });

  const [totalFarmsCount, setTotalFarmsCount] = useState(0);

  const navBarClasses = navBarStyles();

  const { color } = props;

  const appBarClasses = classNames({
    [" " + navBarClasses[color]]: color,
  });

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    fetchFarms(true);
  }, []); //eslint-disable-line

  const fetchFarms = (isInitialLoad) => {
    setIsRequestig(true);
    const paramsToGetFarmers = {
      ...params,
      project_id: "",
      team_id: "",
      village_id: "",
    };

    if (props.match.params.project_id) {
      paramsToGetFarmers.project_id = props.match.params.project_id;
    }

    if (props.match.params.team_id && props.match.params.team_id != "team") {
      paramsToGetFarmers.team_id = props.match.params.team_id;
    }

    if (props.match.params.village_id) {
      paramsToGetFarmers.village_id = props.match.params.village_id;
    }

    getApi(FARMS, paramsToGetFarmers)
      .then(
        (res) => {
          if (isInitialLoad) setTotalFarmsCount(res.meta.total);

          const data = res.data || [];
          const newList = [...farmsList, ...data];
          setFarmsList(newList);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const loadMoreFarms = () => {
    setParams({ ...params, page: (params.page += 1) });
    fetchFarms();
  };

  const handleClickListItem = (event, farm) => {
    setAnchorEl(event.currentTarget);
    setSelectedFarm(farm);
  };

  const handleMenuItemClick = (event, action) => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderFarm = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>crop details</TableCell>
            {/* <TableCell>crop start date</TableCell> */}
            <TableCell>crop harvest date</TableCell>
            <TableCell>Total area</TableCell>
            <TableCell>Village</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {farmsList.map((farm, idx) => (
            <TableRow key={idx}>
              <TableCell component="th" scope="row">
                {farm.name}
              </TableCell>
              <TableCell>{farm.crop_details || "--"}</TableCell>
              {/* <TableCell>
                {moment(farm.crop_start_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell> */}
              <TableCell>
                {moment(farm.crop_harvest_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
              <TableCell>{farm.total_area || "--"}</TableCell>
              <TableCell>
                {farm.village && farm.village.name ? farm.village.name : "--"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
      <AppBar className={navBarClasses.appBar + appBarClasses}>
        <Toolbar className={navBarClasses.container}>
          <div className={navBarClasses.flex}>
            {/* Here we create navbar brand, based on route name */}
            <Button
              color="transparent"
              onClick={() => goBack()}
              className={navBarClasses.title}
              startIcon={<ArrowBackIosIcon />}
            >
              View farmers
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.root}>
        <Loader isLoading={isRequesting} />
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {farmsList.length ? (
              renderFarm()
            ) : (
              <Box
                fontSize="h6.fontSize"
                m={1}
                p={{ xs: 2, sm: 2, md: 2 }}
                style={{ textAlign: "center" }}
              >
                No Farmer Found
              </Box>
            )}
          </GridItem>
        </GridContainer>
      </div>
    </>
  );
}
